import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-mobile-side-menu-title',
    template: `<ng-content></ng-content>`,
    standalone: false
})

export class MobileSideMenuTitleComponent {}
